export default [
    {
        latitude: 37.7884833,
        longitude: -122.3868667,
        timestamp: '2025-10-22T00:00:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.978,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884833,
        longitude: -122.3868667,
        timestamp: '2025-10-22T00:00:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.013000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884833,
        longitude: -122.3868667,
        timestamp: '2025-10-22T00:00:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0006000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884833,
        longitude: -122.38685,
        timestamp: '2025-10-22T00:30:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.988,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884833,
        longitude: -122.38685,
        timestamp: '2025-10-22T00:30:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.013000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884833,
        longitude: -122.38685,
        timestamp: '2025-10-22T00:30:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884833,
        longitude: -122.38685,
        timestamp: '2025-10-22T01:00:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.984,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884833,
        longitude: -122.38685,
        timestamp: '2025-10-22T01:00:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.013000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884833,
        longitude: -122.38685,
        timestamp: '2025-10-22T01:00:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0008,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884833,
        longitude: -122.38685,
        timestamp: '2025-10-22T01:30:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.992,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884833,
        longitude: -122.38685,
        timestamp: '2025-10-22T01:30:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.013000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884833,
        longitude: -122.38685,
        timestamp: '2025-10-22T01:30:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0006000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869167,
        timestamp: '2025-10-22T03:30:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 25.034,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869167,
        timestamp: '2025-10-22T03:30:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869167,
        timestamp: '2025-10-22T03:30:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869167,
        timestamp: '2025-10-22T04:00:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 25.02,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869167,
        timestamp: '2025-10-22T04:00:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.013000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869167,
        timestamp: '2025-10-22T04:00:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0006000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869167,
        timestamp: '2025-10-22T04:30:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 25.052,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869167,
        timestamp: '2025-10-22T04:30:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869167,
        timestamp: '2025-10-22T04:30:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7883833,
        longitude: -122.3873333,
        timestamp: '2025-10-22T21:54:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.757,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7883833,
        longitude: -122.3873333,
        timestamp: '2025-10-22T21:54:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7883833,
        longitude: -122.3873333,
        timestamp: '2025-10-22T21:54:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7883833,
        longitude: -122.3873333,
        timestamp: '2025-10-22T21:55:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.781000000000002,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7883833,
        longitude: -122.3873333,
        timestamp: '2025-10-22T21:55:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.013000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7883833,
        longitude: -122.3873333,
        timestamp: '2025-10-22T21:55:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7883833,
        longitude: -122.3873333,
        timestamp: '2025-10-22T21:55:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.789,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7883833,
        longitude: -122.3873333,
        timestamp: '2025-10-22T21:55:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.013000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7883833,
        longitude: -122.3873333,
        timestamp: '2025-10-22T21:55:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885,
        longitude: -122.3868667,
        timestamp: '2025-10-22T21:48:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.389,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885,
        longitude: -122.3868667,
        timestamp: '2025-10-22T21:48:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885,
        longitude: -122.3868667,
        timestamp: '2025-10-22T21:48:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885,
        longitude: -122.3868667,
        timestamp: '2025-10-22T21:49:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.413,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885,
        longitude: -122.3868667,
        timestamp: '2025-10-22T21:49:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.013000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885,
        longitude: -122.3868667,
        timestamp: '2025-10-22T21:49:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885,
        longitude: -122.3868667,
        timestamp: '2025-10-22T21:49:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.436,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885,
        longitude: -122.3868667,
        timestamp: '2025-10-22T21:49:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885,
        longitude: -122.3868667,
        timestamp: '2025-10-22T21:49:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.3872,
        timestamp: '2025-10-22T21:50:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.490000000000002,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.3872,
        timestamp: '2025-10-22T21:50:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.3872,
        timestamp: '2025-10-22T21:50:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.3872,
        timestamp: '2025-10-22T21:50:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.528000000000002,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.3872,
        timestamp: '2025-10-22T21:50:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.013000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.3872,
        timestamp: '2025-10-22T21:50:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.3872,
        timestamp: '2025-10-22T21:51:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.560000000000002,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.3872,
        timestamp: '2025-10-22T21:51:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.3872,
        timestamp: '2025-10-22T21:51:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-10-22T21:51:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.579,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-10-22T21:51:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-10-22T21:51:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-10-22T21:52:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.604,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-10-22T21:52:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-10-22T21:52:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-10-22T21:52:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.617,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-10-22T21:52:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-10-22T21:52:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869,
        timestamp: '2025-10-22T21:47:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.271,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869,
        timestamp: '2025-10-22T21:47:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869,
        timestamp: '2025-10-22T21:47:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869,
        timestamp: '2025-10-22T21:47:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.303,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869,
        timestamp: '2025-10-22T21:47:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869,
        timestamp: '2025-10-22T21:47:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869,
        timestamp: '2025-10-22T21:48:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.34,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869,
        timestamp: '2025-10-22T21:48:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869,
        timestamp: '2025-10-22T21:48:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884333,
        longitude: -122.3867667,
        timestamp: '2025-10-22T21:39:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.585,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884333,
        longitude: -122.3867667,
        timestamp: '2025-10-22T21:39:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884333,
        longitude: -122.3867667,
        timestamp: '2025-10-22T21:39:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0006000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884333,
        longitude: -122.3867667,
        timestamp: '2025-10-22T21:40:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.652,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884333,
        longitude: -122.3867667,
        timestamp: '2025-10-22T21:40:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884333,
        longitude: -122.3867667,
        timestamp: '2025-10-22T21:40:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884333,
        longitude: -122.3867667,
        timestamp: '2025-10-22T21:40:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.716,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884333,
        longitude: -122.3867667,
        timestamp: '2025-10-22T21:40:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884333,
        longitude: -122.3867667,
        timestamp: '2025-10-22T21:40:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870333,
        timestamp: '2025-10-22T21:41:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.774,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870333,
        timestamp: '2025-10-22T21:41:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870333,
        timestamp: '2025-10-22T21:41:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870333,
        timestamp: '2025-10-22T21:41:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.835,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870333,
        timestamp: '2025-10-22T21:41:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870333,
        timestamp: '2025-10-22T21:41:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870333,
        timestamp: '2025-10-22T21:42:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.877,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870333,
        timestamp: '2025-10-22T21:42:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870333,
        timestamp: '2025-10-22T21:42:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885333,
        longitude: -122.3868167,
        timestamp: '2025-10-22T21:45:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.183,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885333,
        longitude: -122.3868167,
        timestamp: '2025-10-22T21:45:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885333,
        longitude: -122.3868167,
        timestamp: '2025-10-22T21:45:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885333,
        longitude: -122.3868167,
        timestamp: '2025-10-22T21:46:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.19,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885333,
        longitude: -122.3868167,
        timestamp: '2025-10-22T21:46:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885333,
        longitude: -122.3868167,
        timestamp: '2025-10-22T21:46:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885333,
        longitude: -122.3868167,
        timestamp: '2025-10-22T21:46:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.215,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885333,
        longitude: -122.3868167,
        timestamp: '2025-10-22T21:46:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885333,
        longitude: -122.3868167,
        timestamp: '2025-10-22T21:46:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7883833,
        longitude: -122.3872333,
        timestamp: '2025-10-22T21:42:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.912,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7883833,
        longitude: -122.3872333,
        timestamp: '2025-10-22T21:42:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7883833,
        longitude: -122.3872333,
        timestamp: '2025-10-22T21:42:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7883833,
        longitude: -122.3872333,
        timestamp: '2025-10-22T21:43:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.947,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7883833,
        longitude: -122.3872333,
        timestamp: '2025-10-22T21:43:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7883833,
        longitude: -122.3872333,
        timestamp: '2025-10-22T21:43:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7883833,
        longitude: -122.3872333,
        timestamp: '2025-10-22T21:43:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.006,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7883833,
        longitude: -122.3872333,
        timestamp: '2025-10-22T21:43:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7883833,
        longitude: -122.3872333,
        timestamp: '2025-10-22T21:43:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.38715,
        timestamp: '2025-10-22T21:53:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.651,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.38715,
        timestamp: '2025-10-22T21:53:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.013000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.38715,
        timestamp: '2025-10-22T21:53:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0006000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.38715,
        timestamp: '2025-10-22T21:53:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.691,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.38715,
        timestamp: '2025-10-22T21:53:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.013000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.38715,
        timestamp: '2025-10-22T21:53:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.38715,
        timestamp: '2025-10-22T21:54:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.719,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.38715,
        timestamp: '2025-10-22T21:54:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.013000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.38715,
        timestamp: '2025-10-22T21:54:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885,
        longitude: -122.3869,
        timestamp: '2025-10-22T21:44:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.063,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885,
        longitude: -122.3869,
        timestamp: '2025-10-22T21:44:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885,
        longitude: -122.3869,
        timestamp: '2025-10-22T21:44:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885,
        longitude: -122.3869,
        timestamp: '2025-10-22T21:44:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.104,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885,
        longitude: -122.3869,
        timestamp: '2025-10-22T21:44:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885,
        longitude: -122.3869,
        timestamp: '2025-10-22T21:44:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885,
        longitude: -122.3869,
        timestamp: '2025-10-22T21:45:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.145,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885,
        longitude: -122.3869,
        timestamp: '2025-10-22T21:45:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885,
        longitude: -122.3869,
        timestamp: '2025-10-22T21:45:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.3871333,
        timestamp: '2025-10-22T21:56:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.819,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.3871333,
        timestamp: '2025-10-22T21:56:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.013000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.3871333,
        timestamp: '2025-10-22T21:56:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0006000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.3871333,
        timestamp: '2025-10-22T21:56:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.837,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.3871333,
        timestamp: '2025-10-22T21:56:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.013000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.3871333,
        timestamp: '2025-10-22T21:56:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0006000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.3871333,
        timestamp: '2025-10-22T21:57:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.863,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.3871333,
        timestamp: '2025-10-22T21:57:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.013000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884,
        longitude: -122.3871333,
        timestamp: '2025-10-22T21:57:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-10-22T21:38:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.391000000000002,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-10-22T21:38:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-10-22T21:38:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-10-22T21:38:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.46,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-10-22T21:38:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-10-22T21:38:30.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-10-22T21:39:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.522000000000002,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-10-22T21:39:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-10-22T21:39:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885333,
        longitude: -122.38645,
        timestamp: '2025-10-22T02:00:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 25.011,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885333,
        longitude: -122.38645,
        timestamp: '2025-10-22T02:00:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.013000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885333,
        longitude: -122.38645,
        timestamp: '2025-10-22T02:00:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0006000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885333,
        longitude: -122.38645,
        timestamp: '2025-10-22T02:30:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 25.044,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885333,
        longitude: -122.38645,
        timestamp: '2025-10-22T02:30:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.012,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885333,
        longitude: -122.38645,
        timestamp: '2025-10-22T02:30:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885333,
        longitude: -122.38645,
        timestamp: '2025-10-22T03:00:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 25.053,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885333,
        longitude: -122.38645,
        timestamp: '2025-10-22T03:00:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.013000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.7885333,
        longitude: -122.38645,
        timestamp: '2025-10-22T03:00:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.78835,
        longitude: -122.38715,
        timestamp: '2025-10-22T05:00:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 25.055,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.78835,
        longitude: -122.38715,
        timestamp: '2025-10-22T05:00:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.013000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.78835,
        longitude: -122.38715,
        timestamp: '2025-10-22T05:00:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.78835,
        longitude: -122.38715,
        timestamp: '2025-10-22T05:30:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 25.098,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.78835,
        longitude: -122.38715,
        timestamp: '2025-10-22T05:30:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.013000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.78835,
        longitude: -122.38715,
        timestamp: '2025-10-22T05:30:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0004,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.78835,
        longitude: -122.38715,
        timestamp: '2025-10-22T06:00:00.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 25.098,
        unit_type: 'temperature',
        data_type_name: 'bm_aanderaa_salinitysensor_temperature_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.78835,
        longitude: -122.38715,
        timestamp: '2025-10-22T06:00:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.013000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_mean_16bits',
        sensorConfigurations: 72130,
    },
    {
        latitude: 37.78835,
        longitude: -122.38715,
        timestamp: '2025-10-22T06:00:00.000Z',
        sensorPosition: 1,
        units: 'PSU',
        value: 0.0006000000000000001,
        unit_type: 'salinity',
        data_type_name: 'bm_aanderaa_salinity_std_8bits',
        sensorConfigurations: 72130,
    },
];
